import { repeatYearly } from 'owa-locstrings/lib/strings/repeatyearly.locstring.json';
import { repeatMonthly } from 'owa-locstrings/lib/strings/repeatmonthly.locstring.json';
import { repeatWeekly } from 'owa-locstrings/lib/strings/repeatweekly.locstring.json';
import { repeatDaily } from 'owa-locstrings/lib/strings/repeatdaily.locstring.json';
import { repeatNever } from 'owa-locstrings/lib/strings/repeatnever.locstring.json';
import loc from 'owa-localize';

import type RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import {
    isDailyRecurrence,
    isMonthlyRecurrence,
    isWeeklyRecurrence,
    isYearlyRecurrence,
} from './checkRecurrenceTypes';

export default function getSelectedRecurrenceString(recurrence: RecurrenceType): string {
    if (isDailyRecurrence(recurrence)) {
        return loc(repeatDaily);
    } else if (isWeeklyRecurrence(recurrence)) {
        return loc(repeatWeekly);
    } else if (isMonthlyRecurrence(recurrence)) {
        return loc(repeatMonthly);
    } else if (isYearlyRecurrence(recurrence)) {
        return loc(repeatYearly);
    }

    return loc(repeatNever);
}
